<template>
  <div class="bg-[--advantage-background-color]">
    <Carousel v-if="$isMobile() || header.chamadas.length == 1" :autoplay="5000" :wrap-around="true" class="relative w-screen">
      <Slide v-for="(slide, index) in header.chamadas" :key="index">
        <div class="banner-item w-full max-h-[300px] object-cover lazy">
          <div class="advantage_item" style="line-height: 35px;font-size: var(--advantage-text-size);">
            <component :style="{fill: 'var(--advantage-icon-color)'}" class="inline size-6 mr-1" :is="iconComponents[slide.icon_name]" />
            <component :is="getTextType(index)" class="inline text-[--advantage-text-color] text-normal">
              {{ slide.text }}
            </component>
          </div>
        </div>
      </Slide>
    </Carousel>
    <div class="flex justify-between container mx-auto items-center" v-else>
      <div class="flex" v-for="(advantage, index) in header.chamadas" :key="index">
        <div class="flex h-full flex">
          <div class="advantage_item flex items-center" style="line-height: 35px; font-size: var(--advantage-text-size);">
            <component :style="{fill: 'var(--advantage-icon-color)'}" class="inline size-6 mr-1" :is="iconComponents[advantage.icon_name]" />
            <component :is="getTextType(index)" class="inline text-[--advantage-text-color] text-normal">{{ advantage.text }}
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue3-carousel'
import Truck from './Chamadas/Truck.vue';
import Lock from './Chamadas/Lock.vue';
import Card from './Chamadas/Card.vue';
import Pix from './Chamadas/Pix.vue';

export default {
  components: {
    Carousel,
    Slide,
    Truck,
    Card,
    Lock,
    Pix
  },
  inject: ['header'],
  computed: {
    iconComponents() {
      return {
        truck: Truck,
        card: Card,
        lock: Lock,
        pix: Pix
      };
    }
  },
  methods: {
    getTextType(index) {
      return index === 0 ? 'h2' : 'span';
    }
  }
}
</script>
